import classnames from "classnames";

import style from "./style.module.scss";
import type { CenteredModalProps } from "../../types";

function CenteredModal({ className, children }: CenteredModalProps) {
  return (
    <div className={classnames(className, style.container)}>
      <div className={style.innerContainer}>{children}</div>
    </div>
  );
}

export default CenteredModal;
